import storage from '@/plugins/storage.plugins.js';
import entitiesServices from '@/services/entities.services.js';
import messages from '@/constants/messages.js';
import categories from '@/constants/categories.js';
import mixin from '@/mixin/index.js';
import { analytics } from "@/plugins/firebase.js";

const root = { root: true };
export default {
    async clearNavigationHistory({ commit, dispatch, state }) {
        commit("setVirtualScroll", 0);
        commit("setSearchValue", "");
        commit("setShowProducts", false);
        dispatch("clearFilters");
        state.classes = [];
        state.itemsList = [];
        state.hasFilter = false;
        state.presentationList = [];
        state.classesList = [];
        state.brandList = [];
        state.activePrinciplesList = [];
        state.systemClasses = null;
    },
    async clearFilters({ state }) {
        state.dogFilter = false;
        state.catFilter = false;
        state.presentationFilter = undefined;
        state.classesFilter = undefined;
        state.brandFilter = [];
        state.brandLinesFilter = undefined;
        state.activePrinciplesFilter = [];
        state.systemFilter = undefined;
        state.petSizesFilter = [];
        state.petAgesFilter = [];
        state.petBreedsFilter = [];
        state.featuresFilter = [];
    },
    async openCategory({ dispatch, commit }, categoryId) {
        const category = categories[categoryId - 1];
        dispatch("general/logEvent", category.openSectionMethod, root);
        dispatch("clearNavigationHistory");
        try {
            commit('setCategory', category);
            await dispatch("getSummary", { collection: category.collection, temp: false });
            const productsCollection = category.id == 1 ? 'products' : category.productsCollection;
            await dispatch("getProductsSummary", { collection: productsCollection });
        } catch (e) {
            if (e.message && e.message.includes('Network Error') && mixin.methods._isCordovaApp()) {
                dispatch("general/showAlert", { text: messages.ERROR_NETWORK, color: 'black' }, root);
            } else {
                dispatch("general/showError", messages.ERROR, root);
            }
            dispatch('general/routeBack', null, root);
        }
    },
    async getSummary({ commit, state }, { collection, temp }) {
        collection = collection || 'drugs';
        try {
            let summary = {}, summary_name = `${collection}_summary`;
            if (mixin.methods._isCordovaApp()) {
                summary = await storage.storageSelect(summary_name);
            } else if (!state.category || !state.category.orderByPhotos) {
                summary = await entitiesServices.getItem('configuration', summary_name);
            } else {
                summary[collection] = [];
            }
            commit('setDrugsSummary', summary);
            if (temp) {
                summary = await entitiesServices.getItem('configuration', `${collection}_summary_temp`);
                commit('setSummaryTemp', summary);
            }
        } catch (error) {
            console.log(error);
            analytics.logEvent('exception', { id: 'getSummary' });
            throw error;
        }
    },
    async getProductsSummary({ commit, state }, { collection }) {
        try {
            let summary = {}
            collection = collection || 'products';
            let search_collection = collection +
                (!!state.category.orderByPhotos ? `_summary_full` : `_summary`);
            if (mixin.methods._isCordovaApp()) {
                summary = await storage.storageSelect(search_collection);
            } else {
                summary = await entitiesServices.getItem('configuration', search_collection);
            }
            commit('setProductsSummary', summary);
        } catch (error) {
            console.log(error);
            analytics.logEvent('exception', { id: 'getProductsSummary' });
            throw error;
        }
    },
    openItemOrProduct({ dispatch, state }, item) {
        if (item.type) {
            dispatch("general/routePathRedirect", {
                path: `/categories/${item.category || state.category.id}/products/${item.id}`
            }, root);
        } else {
            dispatch("openCategoryItem", { id: item.id, category: item.category || state.category.id, redirect: true });
        }
    },
    async openCategoryItem({ commit, dispatch, state }, { id, category, redirect }) {
        if (redirect) {
            dispatch('general/routePathRedirect', {
                path: `/categories/${category}/drugs/${id}`
            }, root);
            return;
        }
        commit("general/setLoadingOn", null, root);
        try {
            let item = state.drug;
            category = category ? categories[category - 1] : state.category;
            commit('setCategory', category);
            if (!state.drug || state.drug.id != id) {
                commit('setDrug', null);
                commit('setDrugTab', 1);
                if (mixin.methods._isCordovaApp() && category.id == 1) {
                    item = await storage.storageSelect(category.collection, id.replace('percentage', '%').toLowerCase());
                    entitiesServices.getItem(category.collection, id.replace('percentage', '%').toLowerCase(), true);
                } else {
                    item = await entitiesServices.getItem(category.collection, id.toLowerCase());
                }
            }
            commit('setDrug', item);
            await dispatch("mapProducts", item);
        } catch (error) {
            console.log(error);
            analytics.logEvent('exception', { id: 'openCategoryItem' });
            dispatch('general/showError', messages.ERROR_GET_DRUG, root);
            dispatch('general/routeBack', null, root);
        } finally {
            dispatch("general/logEvent", { name: 'open_drug', object: { 'id': id } }, root);
            dispatch("general/logEvent", { name: category.openItemById, object: { 'id': id } }, root);
            commit("general/setLoadingOff", null, root);
        }
    },
    async openProduct({ commit, dispatch, state }, { category, id }) {
        commit("general/setLoadingOn", null, root);
        try {
            let response = state.product;
            category = category ? categories[category - 1] : state.category;
            commit('setCategory', category);
            if (!state.product || state.product.id != id) {
                commit('setProduct', null);
                if (mixin.methods._isCordovaApp() && category.id == 1) {
                    response = await storage.storageSelect('products', id.replace('percentage', '%'));
                    entitiesServices.getItem(category.productsCollection, id.replace('percentage', '%'), true);
                } else {
                    response = await entitiesServices.getItem(category.productsCollection, id);
                }
            }
            if (!state.drugsSummary || !state.drugsSummary[category.collection]) {
                await dispatch('getSummary', { collection: category.collection });
            }
            commit('setProduct', response);
        } catch (error) {
            analytics.logEvent('error', error);
            analytics.logEvent('exception', { id: 'openProduct' });
            dispatch('general/showError', messages.ERROR_GET_PRODUCT, root);
            dispatch('general/routeBack', null, root);
        } finally {
            dispatch("general/logEvent", { name: 'open_product', object: { 'id': id || product.id } }, root);
            if (category) {
                dispatch("general/logEvent", { name: category.openProductById, object: { 'id': id || product.id } }, root);
            }
            commit("general/setLoadingOff", null, root);
        }
    },
    async mapProducts({ commit }, drug) {
        let map = {};
        drug.veterinary_products.forEach(product => {
            if (!map[product.presentation.trim()]) {
                map[product.presentation.trim()] = [];
            }
            map[product.presentation.trim()].push(product);
        });
        commit("setVeterinaryProductsMap", map);
        map = {};
        drug.human_products.forEach(product => {
            product.presentation_volumes.forEach(pv => {
                if (!map[pv.presentation.trim()]) {
                    map[pv.presentation.trim()] = {};
                    map[pv.presentation.trim()][
                        "presentation"
                    ] = pv.presentation.trim();
                }
                if (!map[pv.presentation.trim()][pv.volume.trim()]) {
                    map[pv.presentation.trim()][pv.volume.trim()] = {};
                    map[pv.presentation.trim()][pv.volume.trim()][
                        "volume"
                    ] = pv.volume.trim();
                    map[pv.presentation.trim()][pv.volume.trim()]["products"] = [];
                }
                map[pv.presentation.trim()][pv.volume.trim()]["products"].push(
                    product.name.trim()
                );
            });
        });
        commit("setHumanProductsMap", map);
    },
    openDose({ commit, dispatch, state }, { dose, index, isDrugsManagement }) {
        commit('setDose', dose);
        commit('setDoseIndex', index);
        const { path } = dose;
        if (path) {
            dispatch("general/logEvent", { name: 'openDoseFromReferences', object: { path } }, root);
            dispatch('general/routePathRedirect', { path: path + '?referenced=true' }, root);
        } else if (!isDrugsManagement) {
            dispatch("general/logEvent", {
                name: 'open_dose', object: {
                    title: state.drug.id,
                    dose: index,
                    category: state.category.id
                }
            }, root);
            dispatch('general/routePathRedirect',
                { path: `/categories/${state.category.id}/drugs/${state.drug.id}/doses/${index}` }
                , root);
        }
    },
    openReference({ commit, dispatch, rootGetters }, { reference, from }) {
        commit('setReference', reference);

        if (['calculators', 'transfusion-volume-speed-calculator', 'item'].includes(from.name)) {
            commit('setDrug', from.name == 'item' ? {
                name: rootGetters["topics/item"].name,
                description: ''
            } : {
                name: rootGetters["calculators/calculator"].name,
                description: rootGetters["calculators/calculator"].classes[0]
            });
        }
        analytics.logEvent('open_reference');
        if (!rootGetters["general/isDrugsManagement"]) {
            dispatch('general/routePathRedirect', { path: '/references' }, root);
        }
    },
    async checkInteractions({ commit, dispatch }, { drugs }) {
        commit("general/setLoadingOn", null, root);
        try {
            return await entitiesServices.checkInteractions({ drugs });
        } catch (err) {
            if (!!err && !!err.response && err.response.status == 403) {
                dispatch("purchases/openPurchases", null, root);
            } else {
                dispatch("general/showError", null, root);
            }
            throw err;
        } finally {
            dispatch("general/logEvent", 'interactions_check', root);
            commit("general/setLoadingOff", null, root);
        }
    }
}